import _ from 'lodash';
import { observer } from 'mobx-react';
import { useRef } from 'react';

import ActivityLevels from '@/components/goalbased/Questionarie/ActivityLevelsContainer/ActivityLevelsContainer';
import type {
  GoalBasedQuizRecordModelType,
  QuizButtonSectionRecordModelType,
  QuizInputSectionRecordModelType,
  QuizPlanSectionRecordModelType,
} from '@/models/api';
import { useStore } from '@/models/root-store';

import Plans from './PlansContainer/PlansContainer';
import Profile from './ProfileQuestions/ProfileQuestions';

type Props = {
  goalBasedQuiz: GoalBasedQuizRecordModelType;
  exerciseKey: string;
};

type Section =
  | QuizButtonSectionRecordModelType
  | QuizInputSectionRecordModelType
  | QuizPlanSectionRecordModelType;

export const Questionarie: React.FC<Props> = observer(
  ({ goalBasedQuiz, exerciseKey }) => {
    const { cartStore } = useStore();
    const { goalBased } = cartStore;

    const activityRef = useRef(null);
    const plansRef = useRef(null);

    const { heading = '', sections } = goalBasedQuiz || {};
    const sectionsArray: Section[] = (sections as Section[]) || [];

    const genderSection = _.find(sectionsArray, { key: 'gender' });
    const ageSection = _.find(sectionsArray, { key: 'age' });
    const weightSection = _.find(sectionsArray, { key: 'weight' });
    const exerciseSection = _.find(sectionsArray, {
      key: 'exercise',
    }) as QuizPlanSectionRecordModelType;
    const activeLevelSection = exerciseSection?.plans?.find(
      (section: any) => section.key === exerciseKey
    );
    const daySection = _.find(sectionsArray, { key: 'days' });

    return (
      <div className="m-auto flex justify-start sm:justify-center md:px-12 md:py-20">
        <div className="w-full max-w-[600px] md:w-7/12 lg:w-6/12 xl:w-5/12">
          <div>
            <Profile
              heading={heading as string}
              genderSection={genderSection as QuizButtonSectionRecordModelType}
              ageSection={ageSection as QuizButtonSectionRecordModelType}
              weightSection={weightSection as QuizInputSectionRecordModelType}
            />
            {goalBased.showActivityLevel && (
              <>
                <hr className="mt-6 md:hidden" />
                <div ref={activityRef}>
                  <ActivityLevels activeLevelSection={activeLevelSection} />
                </div>
              </>
            )}
            <hr className="mt-6 md:hidden" />
            {goalBased.showPlans && (
              <div ref={plansRef}>
                <Plans
                  daySection={daySection as QuizButtonSectionRecordModelType}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
);
